import React from "react";
import { motion } from "framer-motion";
import "./Events.css";
import img1 from "../img/1st.webp";
import img2 from "../img/2nd.jpg";
import img3 from "../img/3rd.jpg";
import img4 from "../img/4th.jpg";
import img5 from "../img/5th.jpg";
import img6 from "../img/6th.jpg";
import img7 from "../img/7th.jpg";
import img8 from "../img/8th.jpg";
import shuttleImg from "../img/shuttle.png"; // Shuttlecock Image

const eventData = [
  { img: img1, player: "John Doe" },
  { img: img2, player: "Jane Smith" },
  { img: img3, player: "Mike Johnson" },
  { img: img4, player: "Emma Brown" },
  { img: img5, player: "Chris White" },
  { img: img6, player: "Sophia Green" },
  { img: img7, player: "Daniel Black" },
  { img: img8, player: "Olivia Blue" },
  { img: img1, player: "John Doe" },
  { img: img2, player: "Jane Smith" },
  { img: img3, player: "Mike Johnson" },
  { img: img4, player: "Emma Brown" },
  { img: img5, player: "Chris White" },
  { img: img6, player: "Sophia Green" },
  { img: img7, player: "Daniel Black" },
  { img: img8, player: "Olivia Blue" }
];

function Events() {
  return (
    <div className="events-container">
      {/* Floating Shuttlecocks */}
      {[...Array(6)].map((_, i) => (
        <motion.img
          key={i}
          src={shuttleImg}
          alt="Shuttle"
          className="shuttle"
          animate={{ y: [0, -20, 0] }}
          transition={{ duration: 5 + Math.random() * 2, repeat: Infinity, delay: i * 0.5 }}
        />
      ))}

      {/* Red Dots */}
      {[...Array(30)].map((_, i) => (
        <motion.div
          key={i}
          className="particle"
          style={{
            top: `${Math.random() * 100}%`,
            left: `${Math.random() * 100}%`
          }}
          animate={{ y: [0, -20, 0] }}
          transition={{ duration: 5, repeat: Infinity, delay: Math.random() * 5 }}
        />
      ))}

      <motion.h1
        className="events-title"
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        Tournament Gallery
      </motion.h1>

      <div className="gallery">
        {eventData.map((event, index) => (
          <motion.div
            key={index}
            className="gallery-item"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, delay: index * 0.2 }}
          >
            <div className="card">
              {/* Front - Normal Image */}
              <div className="card-front">
                <img src={event.img} alt={`Event ${index + 1}`} loading="lazy" />
              </div>

              {/* Back - Player Name & Faint Image */}
              <div className="card-back" style={{ backgroundImage: `url(${event.img})` }}>
                <span>{event.player}</span>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}

export default Events;
